module.exports = __webpack_public_path__ + "img/laura-chouette-enQcrUMOp_U-unsplash.59b0403f.jpg";